import React from 'react';
import { ChevronBackSharp } from 'react-ionicons';
import { useHistory } from 'react-router-dom';
import './navbar.css';

const NavbarTitle = ({ title, showIcon }) => {
  const history = useHistory();
  const titleHandler = (title) => {
    return title.split('-').join(' ');
  };

  return (
    <div className="box">
      <h1 style={{ marginTop: '20px', display: 'flex' }} className="title">
        <span
          style={{
            display: showIcon ? 'flex' : 'none',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '50%',
            backgroundColor: '#003876',
            width: '30px',
            height: '30px',
            marginTop: '5px',
            marginRight: '10px',
            cursor: 'pointer',
          }}
          onClick={() => history.push('/gestion-administrador')}>
          <ChevronBackSharp
            width="20px"
            height="20px"
            color={'#fff'}
            style={{ display: 'block', margin: 'auto', paddingRight: '2px' }}
          />
        </span>
        {titleHandler(title)}
      </h1>
    </div>
  );
};

export default NavbarTitle;
